import React, { Fragment, useState, useEffect } from 'react'
import Select from "react-select";

import { Button } from 'react-bootstrap';
import swal from 'sweetalert';
import { addBeneficiary, getBeneficiaryTypes, getBeneficiary, updateBeneficiary } from '../../../helper/BackendHelper';
import { useHistory, useParams } from 'react-router-dom';
import PageLoader from '../../layouts/PageLoader';
import { notifyError } from '../../../helper/notification';

const initialData = {type:[]}

const initialTypes = [
    {
        value: 1,
        label: "Children"
    },
    {
        value: 2,
        label: "Elders"
    },
    {
        value: 3,
        label: "Destitute Women"
    },
    {
        value: 4,
        label: "Physically Challenged"
    },
    {
        value: 5,
        label: "Mentally Challenged"
    },
    {
        value: 6,
        label: "School"
    },
    {
        value: -1,
        label: "Others"
    },
];

const BeneficiaryForm = () => {
    const [formData, setformData] = useState(initialData);
    const [isLoading, setIsLoading] = useState(false);
    const [types, setTypes] = useState(initialTypes);
    const [otherType, setOtherType] = useState(false);

    const router = useHistory();

    const { id } = useParams();

    useEffect(() => {
        initialLoad();
    }, [])

    useEffect(() => {
        if (id && !isLoading) {
            setIsLoading(true);
            getBeneficiary(id).then((res) => {
                if (res?.status === 'success') {
                    let data = res?.data;
                    setIsLoading(false)
                    setformData({
                        name:data.name || '',
                        type:data.oldTypes || [],
                        other_type:data.other_type || '',
                        total_residents:data.total_residents || '',
                        incharge:data.incharge || '',
                        contact_no:data.contact_no || '',
                        location:data.location || '',
                        address:data.address || '',
                        special_preferences:data.special_preferences || '',
                    });
                }
            })
        }
    }, [id])

    useEffect(() => {
        setOtherType(formData.type.includes("-1"));
        if(!formData.type.includes("-1"))
            setformData({...formData, other_type:null});
    }, [formData.type]);

    // Initial load function to fetch data
    const initialLoad = async () => {
        try {
        setIsLoading(true);
        const res = await getBeneficiaryTypes();
        if (res?.status === 'success') {
            let data = res?.data;
            let types = Object.keys(data).map((key) => ({
                value: key,
                label: data[key],
            }));
            setTypes(types);
        }
        } catch (error) {
            console.error('Error loading types:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleTypeChange = (selectedOptions) => {
        let selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setformData({
            ...formData,
            type: selectedValues
        });
    };

    const onChangeValue = (e) => {
        setformData({ ...formData, [e?.currentTarget?.name]: e?.currentTarget?.value })
    }

    const formSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        let res, message = `New Beneficiary added`;
        if(id) {
            message = `Beneficiary details updated`;
            res = await updateBeneficiary(id, formData);
        }
        else
            res = await addBeneficiary(formData);

        if (res?.status === 'success') {
            swal(message, ``, "success")
            setIsLoading(false);
            router.push('/list-of-beneficiaries')
        } else {
            if (res.isAxiosError) {
                if (res?.response?.data?.errors) {
                    Object.values(res?.response?.data?.errors).map((errors) => errors.map((error) => notifyError(error)))
                } else {
                    notifyError(res?.response?.data?.message)
                }
            } else {
                swal("Oops", `${res?.response?.data?.message ? res?.response?.data?.message : res?.message}`, "error")
            }
            setIsLoading(false);
        }
    }

    return (
        <Fragment>
            <PageLoader isLoading={isLoading} >
                {/* <PageTitle activeMenu="Donor" motherMenu="Add New Donor" /> */}
                <div className="row">
                    <div className="col-xl-12 col-lg-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Beneficiary Details</h4>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={formSubmit} autoComplete='off'>
                                        <fieldset disabled={isLoading}>
                                            <div className="row">
                                                <div className={`col-lg-6`}>
                                                    <div className="form-group mb-3">
                                                        <Select
                                                            // defaultValue={selectedOption}
                                                            onChange={handleTypeChange}
                                                            options={types}
                                                            style={{
                                                                lineHeight: "10px",
                                                                color: "#7e7e7e",
                                                                paddingLeft: " 15px",
                                                            }}
                                                            placeholder="Select Type"
                                                            name='type'
                                                            /* value={
                                                                types.filter(option => option.value === formData?.type)
                                                            } */
                                                            value={types.filter(option => formData?.type.some(item => item === option.value))}
                                                            isMulti
                                                        />
                                                    </div>
                                                </div>
                                                {otherType && (
                                                    <div className="col-lg-6">
                                                        <div className="form-group">
                                                            <input
                                                                type="text"
                                                                className="form-control input-default"
                                                                placeholder="Other beneficiary type"
                                                                name='other_type'
                                                                required
                                                                onChange={onChangeValue}
                                                                value={formData?.other_type}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                <div className='clearfix'></div>

                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control input-default"
                                                            placeholder="Name of the Beneficiary"
                                                            name='name'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.name}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="tel"
                                                            className="form-control input-default"
                                                            placeholder="No. of Residents"
                                                            name='total_residents'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.total_residents}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-4">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control input-default"
                                                            placeholder="Incharge Name"
                                                            name='incharge'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.incharge}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-4">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control input-default"
                                                            placeholder="Phone No."
                                                            name='contact_no'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.contact_no}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-4">
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className="form-control input-default"
                                                            placeholder="Location"
                                                            name='location'
                                                            required
                                                            onChange={onChangeValue}
                                                            value={formData?.location}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <textarea name="address" id="address" className="form-control input-default"
                                                            placeholder="Address" rows="7"
                                                            onChange={onChangeValue}
                                                            value={formData?.address}
                                                        >
                                                        </textarea>
                                                    </div>
                                                </div>

                                                <div className="col-lg-6">
                                                    <div className="form-group mb-3">
                                                        <textarea
                                                            name="special_preferences"
                                                            id="special_preferences"
                                                            className="form-control input-default"
                                                            placeholder="Special Preferences"
                                                            rows="7"
                                                            onChange={onChangeValue}
                                                            value={formData?.special_preferences}
                                                        >
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <Button type='submit' variant="primary">{isLoading ? (id ?'Updating....':'Adding') : (id ?'Update':'Add')+' Beneficiary'}</Button>
                                                </div>
                                            </div>
                                        </fieldset>

                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageLoader>

        </Fragment>
    )
}

export default BeneficiaryForm